import React, { memo, useMemo } from "react";
import { object, string, func, array } from "prop-types";
import { useSelector, useDispatch } from "react-redux";
import { selectReporterTab } from "redux/app/selectors";
import { setReporterTab } from "redux/app/actions";
import { selectLabelingHistories } from "redux/labelingHistory/selector";

import style from "../style.module.scss";
import HistoryTab from "./HistoryTab";
import LabelingTab from "./LabelingTab";
import { selectTool } from "redux/tools/actions";
import * as allTools from "redux/tools/enums";
import { Badge } from "@material-ui/core";

export default memo(Panels);

Panels.propTypes = {
  tabObj: object,
};

function Panels({ tabObj }) {
  const dispatch = useDispatch();
  const activeTab = useSelector(selectReporterTab);
  const labelingHistories = useSelector(selectLabelingHistories);

  return (
    <div className={style.panelsContainer}>
      <TabHeader
        activeTab={activeTab}
        setReporterTab={(tab) => {
          dispatch(setReporterTab(tab));
          dispatch(selectTool(allTools.MOVE_MODE));
        }}
        labelingHistories={labelingHistories}
      />

      <LabelingTab tabObj={tabObj} activeTab={activeTab} />

      <HistoryTab activeTab={activeTab} labelingHistories={labelingHistories} />
    </div>
  );
}

TabHeader.propTypes = {
  activeTab: string,
  setReporterTab: func,
  labelingHistories: array,
};

function TabHeader({ activeTab, setReporterTab, labelingHistories = [] }) {
  const hisLength = useMemo(() => labelingHistories.length, [
    labelingHistories,
  ]);

  return (
    <div className={style.tabsHeader}>
      <button
        type="button"
        className={`${style.tabButton} ${
          activeTab === "labeling" ? style.active : ""
        }`}
        onClick={() => setReporterTab("labeling")}
      >
        Labeling
      </button>
      <button
        type="button"
        className={`${style.tabButton} ${
          activeTab === "history" ? style.active : ""
        }`}
        onClick={() => setReporterTab("history")}
        style={{
          pointerEvents: hisLength > 0 ? "auto" : "none",
        }}
      >
        {hisLength > 0 ? (
          <Badge
            badgeContent={hisLength}
            color="primary"
            anchorOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            style={{
              paddingRight: "12px",
            }}
          >
            History
          </Badge>
        ) : (
          "History"
        )}
      </button>
    </div>
  );
}
